import useMrcStore from 'common/stores/mrcStore';
import {MrcTemplate} from 'common/types/store/mrcTypes';
import React from 'react';
import {useTranslation} from 'react-i18next';

export const useGetTemplateName = (
	templateId: string | number
): MrcTemplate | { description: string; id: string | number } => {
	const [t] = useTranslation();
	const {mrcTemplateList, fetchMrcTemplates} = useMrcStore();
	const MRC_TEMPLATES = mrcTemplateList?.templates || [];
	const totalCount = mrcTemplateList?.total_count || 0;

	React.useEffect(() => {
		if (!mrcTemplateList || totalCount === 0) {
			fetchMrcTemplates();
		}
	}, [mrcTemplateList, fetchMrcTemplates, totalCount]);

	const foundTemplate = MRC_TEMPLATES.find(template => {
		const templateIdValue = template.oneflow_template_id;
		if (templateIdValue === undefined || templateIdValue === null) return false;

		return templateIdValue === templateId;
	});

	return foundTemplate
		? foundTemplate
		: {description: t('Unknown Template'), id: 0};
};